import { Plugin } from "@nuxt/types";
import { initializei18n } from "~/utils/i18n";

const accessor: Plugin = context => {
  initializei18n(context.app.i18n);
};

export default accessor;
